<template>
    <div :class="computedClass">
        <div class="eon-search-criteria">
            <EonInputText width="220" label="Adres" name="address" v-model="internalValue.address"
                          @update:modelValue="update" />
            <EonInputText width="220" label="Prace do wykonania" name="comment" v-model="internalValue.comment"
                          @update:modelValue="update" />
            <EonTimePicker width="220" label="Data rozpoczęcia" name="picker" :showTime="false"
                           :modelValue="internalValue.start" @update:modelValue="updateOutageDate" />
            <EonSelectOneAcceptStatus width="220" itemLabel="name" label="Status akceptacji" :empty-value="true"
                                      v-model="internalValue.acceptStatus" @update:modelValue="update"/>
        </div>
    </div>
</template>

<script>
    import EonInputText from "@/components/form/EonInputText";
    import EonTimePicker from "@/components/form/EonTimePicker";
    import EonButton from "@/components/form/EonButton";
    import EonSelectOneAcceptStatus from "@/components/form/EonSelectOneAcceptStatus";

    export default {
        name: "PlannedOutageReadonlySearchCriteria",

        components: {
            EonSelectOneAcceptStatus,
            EonInputText,
            EonTimePicker,
            EonButton,
        },

        props: {
            modelValue: null,
            mapView: {
                default: false,
            },
        },

        emits: ["update:modelValue", "confirmDelete"],

        methods: {
            update() {
                this.$emit("update:modelValue", this.internalValue);
            },

            updateOutageDate(date) {
                if (date) {
                    const start = new Date(date);
                    start.setHours(0, 0, 0, 0);
                    const end = new Date(date);
                    end.setHours(23, 59, 59, 999);
                    this.internalValue.start = start;
                    this.internalValue.end = end;
                } else {
                    this.internalValue.start = null;
                    this.internalValue.end = null;
                }
                this.update();
            },
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
            computedClass() {
                return this.mapView ? "map-view" : "table-view";
            },
        },
    };
</script>

<style lang="less" scoped>
@import "../../assets/less/eon-search-criteria.less";
.table-view .eon-search-criteria {
    justify-content: center;
    gap: 25px;
}
</style>
